import { CardContent, TextField } from '@material-ui/core';
import FancyCard from '../../../components/fancy/FancyCard';
import React from 'react';
import PaymentTerminalFormContainer from '../../../containers/PaymentTerminalFormContainer';

function PaymentFormTerminal({ note, setNote, paymentIntent, setPaymentIntent, methodSlug }) {
    return (
        <FancyCard fullWidth>
            <CardContent>
                <PaymentTerminalFormContainer
                    paymentIntent={paymentIntent}
                    setPaymentIntent={setPaymentIntent}
                    methodSlug={methodSlug}
                />
                <TextField
                    fullWidth
                    label="Private agent notes (to identify the customer)"
                    name="cashnote"
                    placeholder="Fill out with the required information, like room number, booking identifier, etc."
                    type="text"
                    value={note}
                    onChange={ev => {
                        setNote(ev.target.value);
                    }}
                />
            </CardContent>
        </FancyCard>
    );
}

export default PaymentFormTerminal;
